import { handleCleverClassesUserSync } from "store/clever/thunks";
import { handeleCanvasClassUsers, handleListCanvasAssignmentCat } from "store/canvas/thunks";
import { handleGoogleClassRoomStudents } from "store/googleClassRoom/thunks";
import { handlesynClassUsers } from "store/classlink/thunks";
import { handleSyncSchoologyClassesUsers } from "store/schoology/thunks";
import { logToSentry } from "utils/networkErrorUtils";

type StudentSyncUser = {
    canvas_id?: string;
    canvas_auth_id?: string;
    classlinkid?: string;
    classlinkTenantId?: string;
    cleverId?: string;
    googleId?: string;
    schoologyid?: string;
};

type StudentSyncClass = {
    id: string;
    canvas_id?: string;
};

type SyncDispatch = (action: unknown) => unknown;

type HandleStudentSyncParams = {
    currentUser: StudentSyncUser;
    classInfo: StudentSyncClass;
    dispatch: SyncDispatch;
};

export const classCardHandleStudentSync = async ({
    currentUser,
    classInfo,
    dispatch,
}: HandleStudentSyncParams) => {
    try {
        if (currentUser.canvas_id) {
            await handeleCanvasClassUsers(currentUser.canvas_id, currentUser.canvas_auth_id, classInfo.id);
            await dispatch(handleListCanvasAssignmentCat(currentUser.canvas_id, classInfo.canvas_id, currentUser.canvas_auth_id));
        }
        if (currentUser.classlinkid) {
            await handlesynClassUsers(currentUser.classlinkid, currentUser.classlinkTenantId, classInfo.id);
        }
        if (currentUser.cleverId) {
            await handleCleverClassesUserSync(currentUser.cleverId, classInfo.id);
        } else if (currentUser.googleId) {
            await handleGoogleClassRoomStudents(currentUser.googleId, classInfo.id);
        } else if (currentUser.schoologyid) {
            await handleSyncSchoologyClassesUsers(currentUser.schoologyid, classInfo.id);
        }
    } catch (error) {
        logToSentry({
            message: 'Error in student sync issue schoology',
            error,
            module: 'CLASS_CARD',
            operation: 'HANDLE_STUDENT_SYNC'
        });
    }
};
